import { apiService } from './api'
import { LoginRequest, LoginResponse, Admin } from '@/types/api'

export class AuthService {
  // Login
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    // 직접 axios를 사용해서 raw response를 받습니다
    const axiosResponse = await apiService.getClient().post<LoginResponse>('/api/v1/partners/auth/login', credentials)
    const loginResponse = axiosResponse.data
    
    console.log('Raw login response:', loginResponse)
    
    if (loginResponse.access_token) {
      // Store tokens (refresh_token은 선택사항)
      apiService.setAuthTokens(
        loginResponse.access_token,
        loginResponse.refresh_token || ''
      )
    }
    
    return loginResponse
  }

  // Get current partner info
  async getCurrentPartner(): Promise<Admin> {
    const response = await apiService.get<Admin>('/api/v1/partners/profile')
    console.log('🔍 authService.getCurrentPartner() 응답:', response)
    console.log('🔍 response.data:', response.data)
    return response.data!
  }

  // Logout
  async logout(): Promise<void> {
    try {
      await apiService.post('/api/v1/partners/auth/logout')
    } finally {
      // Always clear tokens even if API call fails
      apiService.clearAuthTokens()
    }
  }

  // Check if authenticated
  isAuthenticated(): boolean {
    return apiService.isAuthenticated()
  }

  // Refresh token (if needed)
  async refreshToken(): Promise<LoginResponse> {
    const refreshToken = localStorage.getItem('partner_refresh_token')
    if (!refreshToken) {
      throw new Error('No refresh token available')
    }

    // 파트너 리프레시 엔드포인트 사용
    const response = await apiService.post<LoginResponse>('/api/v1/partners/auth/refresh', {
      refresh_token: refreshToken
    })

    if (response.data) {
      apiService.setAuthTokens(
        response.data.access_token,
        response.data.refresh_token
      )
    }

    return response.data!
  }
}

export const authService = new AuthService()